/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Create_FolderInputs */

const en_files_create_folder = /** @type {(inputs: Files_Create_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create folder`)
};

const es_files_create_folder = /** @type {(inputs: Files_Create_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear carpeta`)
};

/**
* | output |
* | --- |
* | "Create folder" |
*
* @param {Files_Create_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_create_folder = /** @type {((inputs?: Files_Create_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Create_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_create_folder(inputs)
	return en_files_create_folder(inputs)
});